import axios from 'axios';
import type { AxiosError, InternalAxiosRequestConfig } from 'axios';

import { getConfig } from './config';

const axiosInstance = axios.create({});

const getCurrentToken = async () => {
  return new Promise((resolve) => {
    const impToken = sessionStorage.getItem('impersonated_token');
    const accessToken = localStorage.getItem('access_token');

    if (impToken) return resolve(impToken);
    if (accessToken) return resolve(accessToken);
    return resolve(null);
  });
};

axiosInstance.interceptors.request.use(
  async (request: InternalAxiosRequestConfig) => {
    const token = await getCurrentToken();

    if (!token) return request;

    if (request.headers['Skip-Authorization'] === 'true') {
      delete request.headers['Authorization'];
    } else {
      if (token) {
        request.headers['Authorization'] = `Bearer ${token}`;
      }
    }

    delete request.headers['Skip-Authorization'];

    request.headers['ngrok-skip-browser-warning'] = 'true';

    return request;
  },
  (error) => Promise.reject(error),
);
axiosInstance.interceptors.response.use(
  // (response) => response,
  (responseObject) => {
    const responseData = responseObject.data;

    let newResponseData;
    if (responseData?.data?.data) {
      newResponseData = { ...responseData.data };
    } else {
      newResponseData = { ...responseData };
    }

    if (
      !newResponseData?.data ||
      (newResponseData?.data &&
        typeof newResponseData.data === 'object' &&
        !Array.isArray(newResponseData.data) &&
        Object.keys(newResponseData.data).length === 0)
    ) {
      newResponseData.data = [];
    }

    return { ...responseObject, data: newResponseData };
  },
  async (error: AxiosError) => {
    if (error.response?.status === 401) {
      const config = getConfig();
      await config?.clearToken();
    }
    if (error.response?.status === 404 && error.response.data) {
      return Promise.resolve(error.response.data);
    }
    return Promise.reject(error);
  },
);

export default axiosInstance;
